'use client';

import React from 'react';
import { useModalProvider } from '@dr-pam/common-components/Components/Modal/ModalProvider';
import { showLoginModal } from '../../../auth/LoginModal';

type LoginButtonProps = {
	className?: string;
	isLoading: boolean;
};

export default function LoginButton({ className, isLoading }: LoginButtonProps) {
	const modalProvider = useModalProvider();

	return (
		<button
			type="button"
			className={`nav-item login-link ${className ?? ''}`}
			onClick={() => showLoginModal(modalProvider)}
		>
			<span>{isLoading ? 'Loading...' : 'login'}</span>
		</button>
	);
}
